import { Component } from '@angular/core';
import { ProfessionalRolBaseComponent } from '../user-roles/user-roles.base.component';

@Component({
  selector: 'app-role-researcher',
  templateUrl: './role-researcher.component.html',
  styleUrls: ['./role-researcher.component.scss'],
})
export class RoleResearcherComponent extends ProfessionalRolBaseComponent {}
